import "core-js/stable";
import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import { generateFingerPrint } from "@/utils/generateFingerprint";

Vue.config.productionTip = false;

function mountAccount() {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
}

if (process.env.NODE_ENV === "production") {
  generateFingerPrint().finally(mountAccount);
} else {
  mountAccount();
}
